{
  "player_0": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 28,
    "h": 48
  },
  "player_1": {
    "shape": "rect",
    "color": "#7fd3ff",
    "w": 28,
    "h": 48
  },
  "player_2": {
    "shape": "rect",
    "color": "#9b7bff",
    "w": 28,
    "h": 48
  },
  "player_3": {
    "shape": "rect",
    "color": "#ff6b6b",
    "w": 28,
    "h": 48
  },
  "crate": {
    "shape": "rect",
    "color": "#f2b84b",
    "w": 32,
    "h": 32,
    "label": "?",
    "art": {
      "default": {
        "src": "pickups/itembox.webp"
      }
    }
  },
  "coin": {
    "shape": "circle",
    "color": "#ffd43b",
    "w": 16,
    "h": 16,
    "art": {
      "default": {
        "src": "pickups/collectible.webp",
        "w": 13,
        "h": 16,
        "anchor": [0.5, 0.5]
      }
    }
  },
  "spike_ball": {
    "shape": "circle",
    "color": "#868e96",
    "w": 24,
    "h": 24,
    "art": {
      "default": {
        "src": "items/obj_roller.webp"
      }
    }
  },
  "homing_drone": {
    "shape": "poly",
    "color": "#fa5252",
    "w": 32,
    "h": 20,
    "art": {
      "default": {
        "src": "items/obj_homing.webp"
      }
    }
  },
  "trip_wire": {
    "shape": "rect",
    "color": "#ffe066",
    "w": 40,
    "h": 12,
    "art": {
      "default": {
        "src": "items/obj_trap.webp"
      }
    }
  },
  "blade": {
    "shape": "circle",
    "color": "#ced4da",
    "w": 40,
    "h": 40,
    "art": {
      "default": {
        "src": "hazards/swing.webp"
      }
    }
  },
  "spike": {
    "shape": "poly",
    "color": "#e9ecef",
    "w": 16,
    "h": 16,
    "art": {
      "default": {
        "src": "hazards/spikes_up.webp",
        "tile": "x",
        "w": 64
      },
      "retracted": {
        "src": "hazards/spikes_down.webp",
        "tile": "x",
        "w": 64,
        "h": 16,
        "anchor": [0, 1],
        "offset": [0, 1.5]
      }
    }
  },
  "falling_block": {
    "shape": "rect",
    "color": "#495057",
    "w": 64,
    "h": 64,
    "art": {
      "default": {
        "src": "hazards/drop.webp"
      }
    }
  },
  "ground": {
    "shape": "rect",
    "color": "#6b8f3a",
    "w": 32,
    "h": 32
  },
  "ground_top": {
    "shape": "rect",
    "color": "#94c94f",
    "w": 32,
    "h": 8
  },
  "ceiling": {
    "shape": "rect",
    "color": "#5c4b3b",
    "w": 32,
    "h": 32
  },
  "ramp": {
    "shape": "poly",
    "color": "#6b8f3a",
    "w": 32,
    "h": 32
  },
  "mud": {
    "shape": "rect",
    "color": "#7a5230",
    "w": 32,
    "h": 32,
    "art": {
      "default": {
        "src": "tiles/meadow/zone_slow.webp",
        "tile": "x",
        "w": 64,
        "h": 16,
        "offset": [0, -6]
      }
    }
  },
  "speed_strip": {
    "shape": "rect",
    "color": "#22b8cf",
    "w": 32,
    "h": 6,
    "label": ">>",
    "art": {
      "default": {
        "src": "tiles/meadow/zone_speed.webp",
        "tile": "x",
        "w": 64,
        "h": 16
      }
    }
  },
  "bounce_pad": {
    "shape": "rect",
    "color": "#f06595",
    "w": 32,
    "h": 8,
    "art": {
      "default": {
        "src": "tiles/meadow/zone_bounce.webp",
        "h": 16,
        "anchor": [0, 1]
      }
    }
  },
  "platform_moving": {
    "shape": "rect",
    "color": "#a9773c",
    "w": 32,
    "h": 16
  },
  "platform_crumbling": {
    "shape": "rect",
    "color": "#c49a6c",
    "w": 32,
    "h": 16
  },
  "checkpoint": {
    "shape": "rect",
    "color": "#4dabf7",
    "w": 6,
    "h": 64,
    "art": {
      "default": {
        "src": "tiles/meadow/checkpoint.webp",
        "w": 31,
        "h": 60,
        "anchor": [0, 1]
      }
    }
  },
  "finish": {
    "shape": "rect",
    "color": "#ffffff",
    "w": 16,
    "h": 256,
    "art": {
      "default": {
        "src": "tiles/meadow/finish.webp",
        "w": 211,
        "h": 156,
        "anchor": [0.5, 1]
      }
    }
  },
  "bg_sky": {
    "shape": "rect",
    "color": "#9fd8f5",
    "w": 960,
    "h": 540,
    "art": {
      "default": {
        "src": "bg/meadow/sky.webp"
      }
    }
  },
  "bg_far": {
    "shape": "rect",
    "color": "#a3cfc300",
    "w": 1024,
    "h": 512,
    "art": {
      "default": {
        "src": "bg/meadow/far.webp",
        "tile": "x",
        "w": 1280,
        "h": 360,
        "anchor": [0, 1],
        "offset": [0, 170]
      }
    }
  },
  "bg_mid": {
    "shape": "rect",
    "color": "#a3cfc300",
    "w": 1024,
    "h": 384,
    "art": {
      "default": {
        "src": "bg/meadow/mid.webp",
        "tile": "x",
        "w": 1280,
        "h": 280,
        "anchor": [0, 1],
        "offset": [0, 24]
      }
    }
  },
  "bg_near": {
    "shape": "rect",
    "color": "#26331f",
    "w": 1024,
    "h": 256
  },
  "shield_bubble": {
    "shape": "circle",
    "color": "#74c0fc",
    "w": 64,
    "h": 64,
    "art": {
      "default": {
        "src": "items/obj_shield.webp"
      }
    }
  },
  "item_boost_jet": {
    "shape": "poly",
    "color": "#ff922b",
    "w": 32,
    "h": 32,
    "label": "Jet",
    "art": {
      "default": {
        "src": "items/icon_boost.png"
      }
    }
  },
  "item_shield_bubble": {
    "shape": "circle",
    "color": "#74c0fc",
    "w": 32,
    "h": 32,
    "label": "Shield",
    "art": {
      "default": {
        "src": "items/icon_shield.png"
      }
    }
  },
  "item_trip_wire": {
    "shape": "rect",
    "color": "#ffe066",
    "w": 32,
    "h": 32,
    "label": "Wire",
    "art": {
      "default": {
        "src": "items/icon_trap.png"
      }
    }
  },
  "item_spike_ball": {
    "shape": "circle",
    "color": "#868e96",
    "w": 32,
    "h": 32,
    "label": "Spike",
    "art": {
      "default": {
        "src": "items/icon_roller.png"
      }
    }
  },
  "item_homing_drone": {
    "shape": "poly",
    "color": "#fa5252",
    "w": 32,
    "h": 32,
    "label": "Drone",
    "art": {
      "default": {
        "src": "items/icon_homing.png"
      }
    }
  },
  "walk_stone_slab": {
    "shape": "rect",
    "color": "#cbbf98",
    "w": 64,
    "h": 36,
    "art": {
      "default": {
        "src": "kit/meadow/walk_mid.webp",
        "tile": "x",
        "w": 75.0,
        "h": 40.5,
        "offset": [0, -0.0]
      },
      "left": {
        "src": "kit/meadow/walk_left.webp",
        "w": 52.5,
        "h": 46.5,
        "anchor": [0, 0],
        "offset": [0, -5.82]
      },
      "right": {
        "src": "kit/meadow/walk_right.webp",
        "w": 52.5,
        "h": 46.5,
        "anchor": [0, 0],
        "offset": [0, -5.82]
      }
    }
  },
  "walk_boardwalk": {
    "shape": "rect",
    "color": "#a9773c",
    "w": 64,
    "h": 36
  },
  "walk_grass_ledge": {
    "shape": "rect",
    "color": "#6b8f3a",
    "w": 64,
    "h": 36
  },
  "walk_log": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 64,
    "h": 36,
    "art": {
      "default": {
        "src": "kit/walk/log_default.webp",
        "tile": "x",
        "w": 306,
        "h": 55,
        "offset": [0, -9.7]
      },
      "left": {
        "src": "kit/walk/log_left.webp",
        "tile": "x",
        "w": 84.5,
        "h": 68.5,
        "offset": [0, -13.1]
      },
      "right": {
        "src": "kit/walk/log_right.webp",
        "tile": "x",
        "w": 89,
        "h": 68.5,
        "offset": [0, -13.1]
      }
    }
  },
  "strip_speed": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64,
    "h": 36
  },
  "strip_slow": {
    "shape": "rect",
    "color": "#ff6b6b",
    "w": 64,
    "h": 36
  },
  "sign_speed": {
    "shape": "rect",
    "color": "#ffffff",
    "w": 96,
    "h": 41.5
  },
  "sign_slow": {
    "shape": "rect",
    "color": "#ffffff",
    "w": 96,
    "h": 41.5
  },
  "support_pillar": {
    "shape": "rect",
    "color": "#8a7a5a",
    "w": 48,
    "h": 64,
    "art": {
      "default": {
        "src": "kit/meadow/pillar.webp",
        "w": 40.0,
        "h": 99.0,
        "anchor": [0.5, 0]
      },
      "shaft": {
        "src": "kit/meadow/pillar_shaft.webp",
        "tile": "xy",
        "w": 40.0,
        "h": 38.0
      }
    }
  },
  "support_posts": {
    "shape": "rect",
    "color": "#8a7a5a",
    "w": 96,
    "h": 64
  },
  "support_stump": {
    "shape": "rect",
    "color": "#8a7a5a",
    "w": 72,
    "h": 64
  },
  "support_rope": {
    "shape": "rect",
    "color": "#c9a46a",
    "w": 32,
    "h": 128,
    "art": {
      "default": {
        "src": "kit/lagoon/rope.webp",
        "w": 14.0,
        "h": 94.5,
        "anchor": [0.5, 0]
      },
      "shaft": {
        "src": "kit/lagoon/rope_shaft.webp",
        "w": 14.0,
        "h": 84.5,
        "anchor": [0, 0],
        "tile": "xy"
      }
    }
  },
  "support_stalk": {
    "shape": "rect",
    "color": "#8a7a5a",
    "w": 40,
    "h": 64,
    "art": {
      "top": {
        "src": "kit/support/stalk_top.webp",
        "w": 53.5,
        "h": 83,
        "anchor": [0.5, 0]
      },
      "middle": {
        "src": "kit/support/stalk_middle.webp",
        "w": 40,
        "h": 66.5,
        "anchor": [0, 0],
        "tile": "xy"
      },
      "bottom": {
        "src": "kit/support/stalk_bottom.webp",
        "w": 99.5,
        "h": 82.5,
        "anchor": [0.5, 0]
      }
    }
  },
  "obstacle_crate": {
    "shape": "rect",
    "color": "#a9773c",
    "w": 72,
    "h": 64,
    "art": {
      "default": {
        "src": "kit/meadow/obstacle_crate.webp",
        "w": 67.0,
        "h": 64.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "obstacle_barrel_row": {
    "shape": "rect",
    "color": "#a9773c",
    "w": 129.5,
    "h": 64,
    "art": {
      "default": {
        "src": "kit/meadow/obstacle_barrel_row.webp",
        "w": 106.5,
        "h": 56.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "obstacle_rock": {
    "shape": "rect",
    "color": "#9a9078",
    "w": 89,
    "h": 48,
    "art": {
      "default": {
        "src": "kit/meadow/obstacle_rock.webp",
        "w": 83.5,
        "h": 48.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "obstacle_log_pile": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 98.5,
    "h": 64,
    "art": {
      "default": {
        "src": "kit/meadow/obstacle_log_pile.webp",
        "w": 90.0,
        "h": 40.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "bounce_cap": {
    "shape": "rect",
    "color": "#e8553a",
    "w": 96,
    "h": 35.5,
    "art": {
      "default": {
        "src": "kit/bounce_cap.webp",
        "w": 96,
        "h": 35.5,
        "anchor": [0.5, 1]
      }
    }
  },
  "stake_barricade": {
    "shape": "poly",
    "color": "#a0522d",
    "w": 32,
    "h": 48,
    "art": {
      "default": {
        "src": "kit/meadow/stake_barricade.webp",
        "w": 114.5,
        "h": 48.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "spiked_stone": {
    "shape": "circle",
    "color": "#868e96",
    "w": 40,
    "h": 40,
    "art": {
      "default": {
        "src": "kit/meadow/spiked_stone.webp",
        "w": 57.5,
        "h": 40.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "trapdoor": {
    "shape": "rect",
    "color": "#6f4e37",
    "w": 32,
    "h": 8,
    "art": {
      "default": {
        "src": "kit/meadow/trapdoor.webp",
        "w": 96.0,
        "h": 33.0,
        "anchor": [0.5, 1]
      },
      "telegraph": {
        "src": "kit/meadow/trapdoor_telegraph.webp",
        "w": 97.5,
        "h": 48.5,
        "anchor": [0.5, 1]
      },
      "sprung": {
        "src": "kit/meadow/trapdoor_sprung.webp",
        "w": 98.0,
        "h": 75.5,
        "anchor": [0.5, 1]
      }
    }
  },
  "log_ram": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 96,
    "h": 61,
    "art": {
      "default": {
        "src": "kit/meadow/log_ram.webp",
        "w": 56.0,
        "h": 79.0,
        "anchor": [0.5, 0]
      }
    }
  },
  "boulder_drop": {
    "shape": "rect",
    "color": "#9a9078",
    "w": 73,
    "h": 64,
    "art": {
      "default": {
        "src": "kit/meadow/boulder_drop.webp",
        "w": 77.0,
        "h": 64.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "boulder_shadow": {
    "shape": "rect",
    "color": "#000000",
    "w": 72,
    "h": 11,
    "art": {
      "default": {
        "src": "kit/boulder_shadow.webp",
        "w": 72,
        "h": 11,
        "anchor": [0.5, 0.5]
      }
    }
  },
  "decor_flower_giant": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 261.5,
    "h": 240,
    "art": {
      "default": {
        "src": "kit/decor_flower_giant.webp",
        "w": 261.5,
        "h": 240,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_mushroom_tree": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 282.5,
    "h": 240,
    "art": {
      "default": {
        "src": "kit/decor_mushroom_tree.webp",
        "w": 282.5,
        "h": 240,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_waterfall_far": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 158.5,
    "h": 220,
    "art": {
      "default": {
        "src": "kit/decor_waterfall_far.webp",
        "w": 158.5,
        "h": 220,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_waterfall_big": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 446,
    "h": 320,
    "art": {
      "default": {
        "src": "kit/decor_waterfall_big.webp",
        "w": 446,
        "h": 320,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_ruin_arch": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 324,
    "h": 240,
    "art": {
      "default": {
        "src": "kit/decor_ruin_arch.webp",
        "w": 324,
        "h": 240,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_ruin_wall": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 400.5,
    "h": 240,
    "art": {
      "default": {
        "src": "kit/decor_ruin_wall.webp",
        "w": 400.5,
        "h": 240,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_vine_curtain": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 321.5,
    "h": 200,
    "art": {
      "default": {
        "src": "kit/decor_vine_curtain.webp",
        "w": 321.5,
        "h": 200,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_floating_island": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 167.5,
    "h": 150,
    "art": {
      "default": {
        "src": "kit/decor_floating_island.webp",
        "w": 167.5,
        "h": 150,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_thorn_vine_wall": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 515,
    "h": 240,
    "art": {
      "default": {
        "src": "kit/decor_thorn_vine_wall.webp",
        "w": 515,
        "h": 240,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_flower_arch": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 310.5,
    "h": 240,
    "art": {
      "default": {
        "src": "kit/decor_flower_arch.webp",
        "w": 310.5,
        "h": 240,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_finish_island": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 375,
    "h": 300,
    "art": {
      "default": {
        "src": "kit/decor_finish_island.webp",
        "w": 375,
        "h": 300,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_grass_tuft": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 64,
    "h": 44,
    "art": {
      "default": {
        "src": "kit/decor_grass_tuft.webp",
        "w": 64,
        "h": 44,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_rock_small": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 84.5,
    "h": 44,
    "art": {
      "default": {
        "src": "kit/decor_rock_small.webp",
        "w": 84.5,
        "h": 44,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_moss_clump": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 94.5,
    "h": 44,
    "art": {
      "default": {
        "src": "kit/decor_moss_clump.webp",
        "w": 94.5,
        "h": 44,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_mushroom_small": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 60,
    "h": 44,
    "art": {
      "default": {
        "src": "kit/decor_mushroom_small.webp",
        "w": 60,
        "h": 44,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_glow_fungus": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 58.5,
    "h": 44,
    "art": {
      "default": {
        "src": "kit/decor_glow_fungus.webp",
        "w": 58.5,
        "h": 44,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_reeds": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 51.5,
    "h": 44,
    "art": {
      "default": {
        "src": "kit/decor_reeds.webp",
        "w": 51.5,
        "h": 44,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_lily_pads": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 61.5,
    "h": 24,
    "art": {
      "default": {
        "src": "kit/decor_lily_pads.webp",
        "w": 61.5,
        "h": 24,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_thorny_branch": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 59,
    "h": 30,
    "art": {
      "default": {
        "src": "kit/decor_thorny_branch.webp",
        "w": 59,
        "h": 30,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_pottery_broken": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 82.5,
    "h": 44,
    "art": {
      "default": {
        "src": "kit/decor_pottery_broken.webp",
        "w": 82.5,
        "h": 44,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_flag_celebration": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 101.5,
    "h": 56,
    "art": {
      "default": {
        "src": "kit/decor_flag_celebration.webp",
        "w": 101.5,
        "h": 56,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_flower_bush": {
    "shape": "rect",
    "color": "#5a8a3a",
    "w": 69,
    "h": 44,
    "art": {
      "default": {
        "src": "kit/decor_flower_bush.webp",
        "w": 69,
        "h": 44,
        "anchor": [0.5, 1]
      }
    }
  },
  "decor_pitcher_plant": {
    "shape": "rect",
    "color": "#7aa07a",
    "w": 215.6,
    "h": 240,
    "art": {
      "default": {
        "src": "kit/decor_pitcher_plant.webp",
        "w": 215.6,
        "h": 240,
        "anchor": [0.5, 1]
      }
    }
  },
  "platform_static": {
    "shape": "rect",
    "color": "#8d99ae",
    "w": 32,
    "h": 16
  },
  "slow_strip": {
    "shape": "rect",
    "color": "#e03131",
    "w": 32,
    "h": 6,
    "label": "<<"
  },
  "ui_bg_hub": {
    "shape": "rect",
    "color": "#bfe3d6",
    "w": 960,
    "h": 540,
    "art": {
      "default": {
        "src": "ui/bg_hub.webp",
        "w": 960,
        "h": 540
      }
    }
  },
  "ui_icon_gem": {
    "shape": "rect",
    "color": "#9b7bff",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/icon_gem.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_icon_tasks": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/icon_tasks.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_icon_profile": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/icon_profile.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_icon_shop": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/icon_shop.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_icon_settings": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/icon_settings.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_icon_league": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/icon_league.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_icon_friends": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/icon_friends.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_pedestal": {
    "shape": "rect",
    "color": "#c8c8c0",
    "w": 258.0,
    "h": 103.5,
    "art": {
      "default": {
        "src": "ui/pedestal.webp",
        "w": 258.0,
        "h": 103.5,
        "anchor": [0.5, 1]
      }
    }
  },
  "start_post": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 57.0,
    "h": 193.0,
    "art": {
      "default": {
        "src": "tiles/meadow/start_post.webp",
        "w": 57.0,
        "h": 193.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "ui_countdown": {
    "shape": "rect",
    "color": "#fff4d6",
    "w": 128.0,
    "h": 128.0,
    "art": {
      "default": {
        "src": "ui/countdown.webp",
        "frames": 4,
        "fps": 1,
        "loop": false,
        "w": 128.0,
        "h": 128.0,
        "anchor": [0.5, 0.5]
      }
    }
  },
  "ui_podium": {
    "shape": "rect",
    "color": "#d9c38e",
    "w": 514.0,
    "h": 207.0,
    "art": {
      "default": {
        "src": "ui/podium.webp",
        "w": 514.0,
        "h": 207.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "ui_medal_gold": {
    "shape": "rect",
    "color": "#ffd43b",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/medal_gold.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_medal_silver": {
    "shape": "rect",
    "color": "#ffd43b",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/medal_silver.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_medal_bronze": {
    "shape": "rect",
    "color": "#ffd43b",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/medal_bronze.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_slot_hat": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/slot_hat.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_slot_face": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/slot_face.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_slot_top": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/slot_top.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_slot_bottoms": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/slot_bottoms.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_slot_shoes": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/slot_shoes.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_slot_back": {
    "shape": "rect",
    "color": "#4fe3b5",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/slot_back.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "item_oil_slick": {
    "shape": "rect",
    "color": "#ffffff",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "items/icon_oil_slick.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "item_leader_missile": {
    "shape": "rect",
    "color": "#ffffff",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "items/icon_leader_missile.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "item_magnet": {
    "shape": "rect",
    "color": "#ffffff",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "items/icon_magnet.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "oil_slick": {
    "shape": "rect",
    "color": "#2b5a3a",
    "w": 66.0,
    "h": 24.5,
    "art": {
      "default": {
        "src": "items/obj_oil_slick.webp",
        "w": 66.0,
        "h": 24.5,
        "anchor": [0.5, 1]
      }
    }
  },
  "leader_missile": {
    "shape": "rect",
    "color": "#fff4d6",
    "w": 62.0,
    "h": 33.0,
    "art": {
      "default": {
        "src": "items/obj_leader_missile.webp",
        "w": 62.0,
        "h": 33.0,
        "anchor": [0.5, 0.5]
      }
    }
  },
  "ui_league_sprout": {
    "shape": "rect",
    "color": "#c9a15b",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/league_sprout.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_league_brook": {
    "shape": "rect",
    "color": "#c9a15b",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/league_brook.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_league_canopy": {
    "shape": "rect",
    "color": "#c9a15b",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/league_canopy.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_league_summit": {
    "shape": "rect",
    "color": "#c9a15b",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/league_summit.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ui_league_sky": {
    "shape": "rect",
    "color": "#c9a15b",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "ui/league_sky.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ride_jet_snail": {
    "shape": "rect",
    "color": "#ffd8a8",
    "w": 128,
    "h": 96,
    "art": {
      "default": {
        "src": "rides/jet_snail.webp",
        "w": 128,
        "h": 96,
        "anchor": [0.5, 1]
      }
    }
  },
  "ride_thundertoad": {
    "shape": "rect",
    "color": "#ffd8a8",
    "w": 128,
    "h": 96,
    "art": {
      "default": {
        "src": "rides/thundertoad.webp",
        "w": 128,
        "h": 96,
        "anchor": [0.5, 1]
      }
    }
  },
  "ride_wobblebot": {
    "shape": "rect",
    "color": "#ffd8a8",
    "w": 128,
    "h": 96,
    "art": {
      "default": {
        "src": "rides/wobblebot.webp",
        "w": 128,
        "h": 96,
        "anchor": [0.5, 1]
      }
    }
  },
  "ride_pufferloon": {
    "shape": "rect",
    "color": "#ffd8a8",
    "w": 128,
    "h": 96,
    "art": {
      "default": {
        "src": "rides/pufferloon.webp",
        "w": 128,
        "h": 96,
        "anchor": [0.5, 1]
      }
    }
  },
  "ride_drillmole": {
    "shape": "rect",
    "color": "#ffd8a8",
    "w": 128,
    "h": 96,
    "art": {
      "default": {
        "src": "rides/drillmole.webp",
        "w": 128,
        "h": 96,
        "anchor": [0.5, 1]
      }
    }
  },
  "ride_crabwalker": {
    "shape": "rect",
    "color": "#ffd8a8",
    "w": 128,
    "h": 96,
    "art": {
      "default": {
        "src": "rides/crabwalker.webp",
        "w": 128,
        "h": 96,
        "anchor": [0.5, 1]
      }
    }
  },
  "ride_icon_jet_snail": {
    "shape": "rect",
    "color": "#1f4d4a",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "rides/icon_jet_snail.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ride_icon_thundertoad": {
    "shape": "rect",
    "color": "#1f4d4a",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "rides/icon_thundertoad.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ride_icon_wobblebot": {
    "shape": "rect",
    "color": "#1f4d4a",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "rides/icon_wobblebot.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ride_icon_pufferloon": {
    "shape": "rect",
    "color": "#1f4d4a",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "rides/icon_pufferloon.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ride_icon_drillmole": {
    "shape": "rect",
    "color": "#1f4d4a",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "rides/icon_drillmole.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "ride_icon_crabwalker": {
    "shape": "rect",
    "color": "#1f4d4a",
    "w": 64.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "rides/icon_crabwalker.webp",
        "w": 64.0,
        "h": 64.0
      }
    }
  },
  "driftroot_lagoon:walk_boardwalk": {
    "shape": "rect",
    "color": "#b07a45",
    "w": 64,
    "h": 32,
    "art": {
      "default": {
        "src": "kit/lagoon/walk_boardwalk_mid.webp",
        "tile": "x",
        "w": 170.5,
        "h": 41.0,
        "offset": [0, -0.8]
      },
      "left": {
        "src": "kit/lagoon/walk_boardwalk_left.webp",
        "w": 18.0,
        "h": 43.5,
        "anchor": [0, 0],
        "offset": [0, -3.7]
      },
      "right": {
        "src": "kit/lagoon/walk_boardwalk_right.webp",
        "w": 18.0,
        "h": 43.5,
        "anchor": [0, 0],
        "offset": [0, -3.7]
      }
    }
  },
  "driftroot_lagoon:walk_rope_bridge": {
    "shape": "rect",
    "color": "#b07a45",
    "w": 64,
    "h": 32,
    "art": {
      "default": {
        "src": "kit/lagoon/walk_rope_bridge_mid.webp",
        "tile": "x",
        "w": 113.5,
        "h": 42.0,
        "offset": [0, -18.2]
      },
      "left": {
        "src": "kit/lagoon/walk_rope_bridge_left.webp",
        "w": 22.5,
        "h": 47.0,
        "anchor": [0, 0],
        "offset": [0, -23.2]
      },
      "right": {
        "src": "kit/lagoon/walk_rope_bridge_right.webp",
        "w": 22.5,
        "h": 47.0,
        "anchor": [0, 0],
        "offset": [0, -23.2]
      }
    }
  },
  "driftroot_lagoon:walk_raft": {
    "shape": "rect",
    "color": "#b07a45",
    "w": 64,
    "h": 32,
    "art": {
      "default": {
        "src": "kit/lagoon/walk_raft_mid.webp",
        "tile": "x",
        "w": 226.0,
        "h": 44.5,
        "offset": [0, -0.5]
      },
      "left": {
        "src": "kit/lagoon/walk_raft_left.webp",
        "w": 40.0,
        "h": 55.0,
        "anchor": [0, 0],
        "offset": [0, -10.8]
      },
      "right": {
        "src": "kit/lagoon/walk_raft_right.webp",
        "w": 40.0,
        "h": 55.0,
        "anchor": [0, 0],
        "offset": [0, -10.8]
      },
      "sunk": {
        "src": "kit/lagoon/walk_raft_sunk.webp",
        "tile": "x",
        "w": 270.5,
        "h": 57.0,
        "offset": [0, -29.3]
      }
    }
  },
  "driftroot_lagoon:support_posts": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 48,
    "h": 112,
    "art": {
      "default": {
        "src": "kit/lagoon/posts.webp",
        "w": 48.0,
        "h": 95.5,
        "anchor": [0.5, 0]
      },
      "shaft": {
        "src": "kit/lagoon/posts_shaft.webp",
        "w": 48.0,
        "h": 72.5,
        "anchor": [0, 0],
        "tile": "xy"
      }
    }
  },
  "driftroot_lagoon:support_stalk": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 48,
    "h": 112,
    "art": {
      "default": {
        "src": "kit/lagoon/posts.webp",
        "w": 48.0,
        "h": 95.5,
        "anchor": [0.5, 0]
      },
      "shaft": {
        "src": "kit/lagoon/posts_shaft.webp",
        "w": 48.0,
        "h": 72.5,
        "anchor": [0, 0],
        "tile": "xy"
      }
    }
  },
  "driftroot_lagoon:bounce_cap": {
    "shape": "rect",
    "color": "#7cc35a",
    "w": 128,
    "h": 96,
    "art": {
      "default": {
        "src": "kit/lagoon/lily_post.webp",
        "w": 128.0,
        "h": 94.0,
        "anchor": [0.5, 1]
      },
      "float": {
        "src": "kit/lagoon/lily_float.webp",
        "w": 160.0,
        "h": 69.5,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:barrel_roll": {
    "shape": "circle",
    "color": "#8a5a2b",
    "w": 48,
    "h": 48,
    "art": {
      "barrel": {
        "src": "kit/lagoon/barrel.webp",
        "w": 48.0,
        "h": 45.0,
        "anchor": [0.5, 0.5]
      },
      "default": {
        "src": "kit/lagoon/gate_default.webp",
        "w": 117.0,
        "h": 96.0,
        "anchor": [0.5, 1]
      },
      "gate_default": {
        "src": "kit/lagoon/gate_default.webp",
        "w": 117.0,
        "h": 96.0,
        "anchor": [0.5, 1]
      },
      "gate_telegraph": {
        "src": "kit/lagoon/gate_telegraph.webp",
        "w": 115.5,
        "h": 96.0,
        "anchor": [0.5, 1]
      },
      "gate_open": {
        "src": "kit/lagoon/gate_open.webp",
        "w": 148.0,
        "h": 96.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:spiked_stone": {
    "shape": "circle",
    "color": "#8a6a3a",
    "w": 40,
    "h": 40,
    "art": {
      "default": {
        "src": "kit/lagoon/barnacle_burr.webp",
        "w": 33.5,
        "h": 40.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:boulder_drop": {
    "shape": "rect",
    "color": "#a9773c",
    "w": 64,
    "h": 64,
    "art": {
      "default": {
        "src": "kit/lagoon/crate_drop.webp",
        "w": 46.0,
        "h": 64.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:obstacle_rock": {
    "shape": "rect",
    "color": "#5a7a3a",
    "w": 64,
    "h": 64,
    "art": {
      "default": {
        "src": "kit/lagoon/root_knot.webp",
        "w": 60.5,
        "h": 64.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:trapdoor": {
    "shape": "rect",
    "color": "#6f4e37",
    "w": 32,
    "h": 8,
    "art": {
      "default": {
        "src": "kit/lagoon/trapdoor.webp",
        "w": 96.0,
        "h": 38.5,
        "anchor": [0.5, 1]
      },
      "telegraph": {
        "src": "kit/lagoon/trapdoor_telegraph.webp",
        "w": 94.5,
        "h": 42.0,
        "anchor": [0.5, 1]
      },
      "sprung": {
        "src": "kit/lagoon/trapdoor_sprung.webp",
        "w": 102.0,
        "h": 42.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:stake_barricade": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 105.0,
    "h": 48.0,
    "art": {
      "default": {
        "src": "kit/lagoon/stake_barricade.webp",
        "w": 105.0,
        "h": 48.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:log_ram": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 96.0,
    "h": 61.0,
    "art": {
      "default": {
        "src": "kit/lagoon/log_ram.webp",
        "w": 96.0,
        "h": 61.0,
        "anchor": [0.5, 0]
      }
    }
  },
  "driftroot_lagoon:obstacle_crate": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 72.0,
    "h": 64.0,
    "art": {
      "default": {
        "src": "kit/lagoon/obstacle_crate.webp",
        "w": 72.0,
        "h": 64.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:obstacle_barrel_row": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 129.5,
    "h": 64.0,
    "art": {
      "default": {
        "src": "kit/lagoon/obstacle_barrel_row.webp",
        "w": 129.5,
        "h": 64.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:obstacle_log_pile": {
    "shape": "rect",
    "color": "#8a5a2b",
    "w": 98.5,
    "h": 64.0,
    "art": {
      "default": {
        "src": "kit/lagoon/obstacle_log_pile.webp",
        "w": 98.5,
        "h": 64.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_mangrove_tree": {
    "shape": "rect",
    "color": "#5a8a6a",
    "w": 64,
    "h": 520,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_mangrove_tree.webp",
        "w": 530.5,
        "h": 520.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_root_arch": {
    "shape": "rect",
    "color": "#5a8a6a",
    "w": 64,
    "h": 360,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_root_arch.webp",
        "w": 584.0,
        "h": 360.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_mangrove_roots": {
    "shape": "rect",
    "color": "#5a8a6a",
    "w": 64,
    "h": 200,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_mangrove_roots.webp",
        "w": 257.5,
        "h": 200.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_giant_lily_far": {
    "shape": "rect",
    "color": "#5a8a6a",
    "w": 64,
    "h": 120,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_giant_lily_far.webp",
        "w": 232.0,
        "h": 120.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_mist_bank": {
    "shape": "rect",
    "color": "#5a8a6a",
    "w": 64,
    "h": 160,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_mist_bank.webp",
        "w": 671.0,
        "h": 160.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_waterfall_roots": {
    "shape": "rect",
    "color": "#5a8a6a",
    "w": 64,
    "h": 340,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_waterfall_roots.webp",
        "w": 357.5,
        "h": 340.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_lily_island": {
    "shape": "rect",
    "color": "#5a8a6a",
    "w": 64,
    "h": 220,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_lily_island.webp",
        "w": 325.0,
        "h": 220.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_finish_driftwood_arch": {
    "shape": "rect",
    "color": "#5a8a6a",
    "w": 64,
    "h": 300,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_finish_driftwood_arch.webp",
        "w": 348.5,
        "h": 300.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_rope_coil": {
    "shape": "rect",
    "color": "#b07a45",
    "w": 48,
    "h": 24,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_rope_coil.webp",
        "w": 52.5,
        "h": 24.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_barrel_small": {
    "shape": "rect",
    "color": "#b07a45",
    "w": 48,
    "h": 56,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_barrel_small.webp",
        "w": 39.0,
        "h": 56.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_shell_cluster": {
    "shape": "rect",
    "color": "#b07a45",
    "w": 48,
    "h": 24,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_shell_cluster.webp",
        "w": 41.0,
        "h": 24.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_net_hung": {
    "shape": "rect",
    "color": "#b07a45",
    "w": 48,
    "h": 80,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_net_hung.webp",
        "w": 35.0,
        "h": 80.0,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:decor_dragonfly": {
    "shape": "rect",
    "color": "#3fb8b0",
    "w": 32,
    "h": 33.5,
    "art": {
      "default": {
        "src": "kit/lagoon/decor_dragonfly.webp",
        "frames": 2,
        "fps": 12,
        "w": 32,
        "h": 33.5,
        "anchor": [0.5, 1]
      }
    }
  },
  "driftroot_lagoon:bg_mid": {
    "shape": "rect",
    "color": "#a3cfc300",
    "w": 1024,
    "h": 384,
    "art": {
      "default": {
        "src": "kit/lagoon/mid.webp",
        "tile": "x",
        "w": 721,
        "h": 300,
        "anchor": [0, 1],
        "offset": [0, 120]
      }
    }
  },
  "driftroot_lagoon:bg_far": {
    "shape": "rect",
    "color": "#a3cfc300",
    "w": 1024,
    "h": 512
  },
  "driftroot_lagoon:bg_sky": {
    "shape": "rect",
    "color": "#bfe0dc",
    "w": 960,
    "h": 540,
    "art": {
      "default": {
        "src": "kit/lagoon/sky.webp"
      }
    }
  },
  "walk_rope_bridge": {
    "shape": "rect",
    "color": "#b8864b",
    "w": 64,
    "h": 24
  },
  "walk_raft": {
    "shape": "rect",
    "color": "#9c6b3c",
    "w": 64,
    "h": 32
  },
  "barrel_roll": {
    "shape": "circle",
    "color": "#8b5a2b",
    "w": 40,
    "h": 40
  },
  "decor_mangrove_tree": {
    "shape": "rect",
    "color": "#4f7a5a",
    "w": 480,
    "h": 520
  },
  "decor_root_arch": {
    "shape": "rect",
    "color": "#6d5a3f",
    "w": 400,
    "h": 360
  },
  "decor_mangrove_roots": {
    "shape": "rect",
    "color": "#5f5038",
    "w": 320,
    "h": 200
  },
  "decor_giant_lily_far": {
    "shape": "rect",
    "color": "#5e9c6a",
    "w": 240,
    "h": 120
  },
  "decor_mist_bank": {
    "shape": "rect",
    "color": "#d8eee9",
    "w": 600,
    "h": 160
  },
  "decor_waterfall_roots": {
    "shape": "rect",
    "color": "#7fb8c8",
    "w": 300,
    "h": 340
  },
  "decor_lily_island": {
    "shape": "rect",
    "color": "#6aa86f",
    "w": 520,
    "h": 220
  },
  "decor_finish_driftwood_arch": {
    "shape": "rect",
    "color": "#c9b48f",
    "w": 320,
    "h": 300
  },
  "decor_rope_coil": {
    "shape": "rect",
    "color": "#c8a46a",
    "w": 64,
    "h": 40
  },
  "decor_barrel_small": {
    "shape": "rect",
    "color": "#8b5a2b",
    "w": 48,
    "h": 56
  },
  "decor_shell_cluster": {
    "shape": "rect",
    "color": "#f1d3c2",
    "w": 72,
    "h": 32
  },
  "decor_net_hung": {
    "shape": "rect",
    "color": "#b39b72",
    "w": 96,
    "h": 80
  },
  "decor_dragonfly": {
    "shape": "rect",
    "color": "#2fb5a8",
    "w": 32,
    "h": 16
  },
  "driftroot_lagoon:ui_podium": {
    "shape": "rect",
    "color": "#b07a45",
    "w": 516,
    "h": 187,
    "art": {
      "default": {
        "src": "ui/podium_lagoon.webp",
        "w": 516,
        "h": 187,
        "anchor": [0.5, 1]
      }
    }
  }
}
